var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { useCardSubscriptionAsyncCheckoutState } from "./state/useCardSubscriptionAsyncCheckoutState";
import { Box, Button, Grid, InputAdornment, TextField, } from "@material-ui/core";
import { Translate as T } from "react-localize-redux";
import { Mail } from "react-feather";
import { makeStyles } from "@material-ui/core/styles";
import { WebPay } from "../../assets/logos";
import InputMask from "react-input-mask";
import BrandIcon from "../commons/BrandIcon/BrandIcon";
import { useCheckoutContext } from "../../context/useCheckoutContext";
import TermsConditions from "../commons/TermsConditions/TermsConditions";
export var useStyles = makeStyles(function (theme) {
    var _a, _b, _c, _d;
    return ({
        button: {
            borderRadius: 8,
            "&.Mui-disabled": {
                backgroundColor: theme.palette.primary.main,
                color: "#FFFFFF",
            },
        },
        formContainer: (_a = {
                marginBottom: 40,
                marginTop: 40
            },
            _a[theme.breakpoints.down("xs")] = {
                marginBottom: 0,
                marginTop: 8,
            },
            _a),
        gridButton: (_b = {
                paddingBottom: 0,
                paddingTop: 12,
                width: "100%"
            },
            _b[theme.breakpoints.down("xs")] = {
                paddingBottom: 0,
                paddingTop: 8,
            },
            _b),
        gridIcon: (_c = {
                paddingBottom: 12,
                paddingTop: 0
            },
            _c[theme.breakpoints.down("xs")] = {
                paddingBottom: 8,
                paddingTop: 0,
            },
            _c),
        gridItem: (_d = {
                paddingBottom: 12,
                paddingTop: 12,
                width: "100%"
            },
            _d[theme.breakpoints.down("xs")] = {
                paddingBottom: 8,
                paddingTop: 8,
            },
            _d),
        iconMail: {
            marginRight: 15,
        },
        placeholder: {
            "& input": {
                color: "#6D7781",
            },
            borderRadius: 8,
        },
        terms: {
            width: "100%",
        },
        webpay: {
            height: theme.spacing(4.5),
            width: theme.spacing(12),
        },
    });
});
export var CheckoutCardSubscriptionAsync = function () {
    var classes = useStyles();
    var _a = useCardSubscriptionAsyncCheckoutState(), form = _a.form, handler = _a.handler, handleTermsModal = _a.handleTermsModal, termsModal = _a.termsModal, cardBrand = _a.cardBrand;
    var readOnly = useCheckoutContext().readOnly;
    return (React.createElement("form", { onSubmit: form.handleSubmit(handler.handleSubmit), className: classes.formContainer },
        React.createElement(T, null, function (_a) {
            var translate = _a.translate;
            var _b;
            return (React.createElement(Grid, { container: true, direction: "column", alignItems: "center" },
                React.createElement(Grid, { item: true, xs: 12, className: classes.gridIcon },
                    React.createElement(WebPay, { className: classes.webpay })),
                React.createElement(Grid, { item: true, xs: 12, className: classes.gridItem },
                    React.createElement(InputMask, { onChange: function (e) {
                            return e.target.value.replace(/ /g, "").length > 8 ||
                                e.target.value.replace(/ /g, "").length === 0
                                ? handler.handleSetFields()
                                : null;
                        }, mask: "9999 9999 9999 9999 99", maskChar: null }, function (inputProps) { return (React.createElement(TextField, __assign({}, inputProps, { fullWidth: true, "aria-current": true, name: "cardNumber", inputRef: form.register({
                            minLength: {
                                message: (React.createElement(T, { id: "form.numberCardInvalid" })),
                                value: 16,
                            },
                            required: {
                                message: (React.createElement(T, { id: "form.fieldRequired" })),
                                value: true,
                            },
                        }), variant: "outlined", placeholder: translate("cardCheckout.cardNumber"), error: !!form.errors.cardNumber, helperText: !!form.errors["cardNumber"] &&
                            form.errors["cardNumber"].message, InputProps: {
                            className: classes.placeholder,
                            startAdornment: (React.createElement(InputAdornment, { position: "start", className: classes.iconMail },
                                React.createElement(BrandIcon, { image: cardBrand }))),
                        } }))); })),
                React.createElement(Grid, { item: true, xs: 12, className: classes.gridItem },
                    React.createElement(TextField, { fullWidth: true, "aria-current": true, name: "email", inputRef: form.register({
                            pattern: {
                                message: (React.createElement(T, { id: "form.emailInvalid" })),
                                value: new RegExp("^[\\w-.]+@([\\w-]+\\.)+[\\w-]+$"),
                            },
                            required: {
                                message: (React.createElement(T, { id: "form.fieldRequired" })),
                                value: true,
                            },
                        }), variant: "outlined", placeholder: translate("cardSubscriptionAsync.email"), error: !!form.errors.email, helperText: !!form.errors["email"] && ((_b = form.errors["email"]) === null || _b === void 0 ? void 0 : _b.message), InputProps: {
                            className: classes.placeholder,
                            startAdornment: (React.createElement(InputAdornment, { position: "start", className: classes.iconMail },
                                React.createElement(Mail, { color: "#6D7781", size: 22 }))),
                        } })),
                React.createElement(Grid, { item: true, xs: 12, className: classes.terms },
                    React.createElement(TermsConditions, { form: form, open: termsModal, setOpenTerms: handleTermsModal })),
                React.createElement(Grid, { item: true, xs: 12, className: classes.gridButton },
                    React.createElement(Box, { display: "flex", justifyContent: "center" },
                        React.createElement(Button, { disabled: readOnly, type: "submit", variant: "contained", fullWidth: true, color: "primary", size: "large", className: classes.button },
                            React.createElement(T, { id: "subscriptionButton" }))))));
        })));
};
